/**
 * DayTabNavigation - Navigation par onglets des jours pour prestations multi-jours
 */
import React, { memo } from 'react';

const DayTabNavigation = memo(({
  days = [],
  activeDayTab = 0,
  dayParticipants = {},
  deletingDay = null,
  onDayChange,
  onDeleteDay
}) => {
  if (days.length <= 1) return null;

  return (
    <div className="pi-day-navigation">
      {days.map((day, index) => (
        <button
          key={day.date}
          type="button"
          onClick={() => onDayChange(index)}
          className={`pi-day-tab ${activeDayTab === index ? 'pi-day-tab--active' : ''}`}
          style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
        >
          <span>{day.label}</span>
          <span className="pi-day-tab__count">
            {dayParticipants[day.date]?.length || 0}
          </span>

          {/* Bouton supprimer jour (si plus d'1 jour) */}
          {days.length > 1 && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                onDeleteDay?.(day, index);
              }}
              style={{
                width: '18px',
                height: '18px',
                marginLeft: '4px',
                border: 'none',
                borderRadius: '50%',
                background: deletingDay === day.date ? '#ccc' : 'rgba(220, 53, 69, 0.9)',
                color: 'white',
                fontSize: '12px',
                fontWeight: 'bold',
                cursor: deletingDay === day.date ? 'wait' : 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                lineHeight: 1
              }}
              title={`Supprimer le ${day.label || day.date}`}
            >
              {deletingDay === day.date ? '…' : '×'}
            </span>
          )}
        </button>
      ))}
    </div>
  );
});

DayTabNavigation.displayName = 'DayTabNavigation';

export default DayTabNavigation;
